var map = {
	"./account/accountedit.vue": [
		"1fd7",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-7f6a9a81"
	],
	"./account/accountview.vue": [
		"c382",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-7f6a9a81",
		"chunk-14fbaad8"
	],
	"./account/changepassword.vue": [
		"69f5",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-06bb4321"
	],
	"./applicants/add.vue": [
		"2dc2",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-066bce7c"
	],
	"./applicants/admissions.vue": [
		"2a55",
		"chunk-1ec6ab12",
		"chunk-2630954e"
	],
	"./applicants/applicantlist.vue": [
		"9b2d",
		"chunk-1ec6ab12",
		"chunk-31cf130c"
	],
	"./applicants/capsmall.vue": [
		"802d",
		"chunk-1ec6ab12",
		"chunk-051d51ae"
	],
	"./applicants/capsmall_applications.vue": [
		"3a33",
		"chunk-1ec6ab12",
		"chunk-3e2993a6"
	],
	"./applicants/capsmall_offeradmission.vue": [
		"dbcc",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-7fa0c72f"
	],
	"./applicants/capsmallselections.vue": [
		"b617",
		"chunk-1ec6ab12",
		"chunk-52822e0e"
	],
	"./applicants/confirmed_admissions.vue": [
		"a7f3",
		"chunk-1ec6ab12",
		"chunk-24bf4402"
	],
	"./applicants/edit.vue": [
		"f8f5",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-4399b23e"
	],
	"./applicants/list.vue": [
		"e665",
		"chunk-1ec6ab12",
		"chunk-5134a62f"
	],
	"./applicants/programmeselections.vue": [
		"c04a",
		"chunk-1ec6ab12",
		"chunk-4f384328"
	],
	"./applicants/view.vue": [
		"e15b",
		"chunk-1ec6ab12",
		"chunk-439992bc"
	],
	"./caps_institutions_list/edit.vue": [
		"da07",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-fe550f70"
	],
	"./caps_institutions_list/list.vue": [
		"c390",
		"chunk-1ec6ab12",
		"chunk-4a0e5574"
	],
	"./caps_institutions_list/view.vue": [
		"c37a",
		"chunk-1ec6ab12",
		"chunk-a28bd268"
	],
	"./caps_mall_activities/add.vue": [
		"00cd",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-0a28fe35"
	],
	"./caps_mall_activities/edit.vue": [
		"348d",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-f83d1496"
	],
	"./caps_mall_activities/list.vue": [
		"5d19",
		"chunk-1ec6ab12",
		"chunk-18232194"
	],
	"./caps_mall_activities/view.vue": [
		"751a",
		"chunk-1ec6ab12",
		"chunk-75580e50"
	],
	"./caps_programmes_list/add.vue": [
		"f175",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-50b3a0ed"
	],
	"./caps_programmes_list/edit.vue": [
		"b0f6",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-4fccdc84"
	],
	"./caps_programmes_list/list.vue": [
		"54b7",
		"chunk-1ec6ab12",
		"chunk-c132819a"
	],
	"./caps_programmes_list/view.vue": [
		"72b9",
		"chunk-1ec6ab12",
		"chunk-697ff0d4"
	],
	"./custom/capsoverview.vue": [
		"e363",
		"chunk-1ec6ab12",
		"chunk-2d2250a1"
	],
	"./custom/file_svg.vue": [
		"5eb6",
		"chunk-2d0d3fda"
	],
	"./custom/help.vue": [
		"e91d",
		"chunk-1ec6ab12",
		"chunk-2d2266bd"
	],
	"./errors/forbidden.vue": [
		"601c",
		"chunk-2d0ce782"
	],
	"./errors/pagenotfound.vue": [
		"422c",
		"chunk-2d0c0665"
	],
	"./home/home.vue": [
		"22cd",
		"chunk-1ec6ab12",
		"chunk-2d0b2397"
	],
	"./index/accountblocked.vue": [
		"d2e9",
		"chunk-2d21de38"
	],
	"./index/accountcreated.vue": [
		"6dd8",
		"chunk-2d0db0b8"
	],
	"./index/accountinactive.vue": [
		"760d",
		"chunk-2d0d7249"
	],
	"./index/accountpending.vue": [
		"6300",
		"chunk-2d0cf273"
	],
	"./index/emailverified.vue": [
		"30ac",
		"chunk-2d0b9035"
	],
	"./index/forgotpassword.vue": [
		"038c",
		"chunk-1ec6ab12",
		"chunk-2d0a3964"
	],
	"./index/index.vue": [
		"f75a",
		"chunk-1ec6ab12",
		"chunk-2d22d413"
	],
	"./index/resetpassword.vue": [
		"61c2",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-06bb24b9"
	],
	"./index/resetpassword_completed.vue": [
		"3516",
		"chunk-2d0b9cfd"
	],
	"./index/userregister.vue": [
		"2320",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-00d72f1e"
	],
	"./index/verifyemail.vue": [
		"900b",
		"chunk-1ec6ab12",
		"chunk-2d0e447f"
	],
	"./index/verifyotp.vue": [
		"1c93",
		"chunk-1ec6ab12",
		"chunk-199dcffb"
	],
	"./institution_account_permissions/add.vue": [
		"5c61",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-0d2aab94"
	],
	"./institution_account_permissions/edit.vue": [
		"1fbc",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-60b35f53"
	],
	"./institution_account_permissions/list.vue": [
		"2948",
		"chunk-1ec6ab12",
		"chunk-3250c20a"
	],
	"./institution_account_permissions/view.vue": [
		"8765",
		"chunk-1ec6ab12",
		"chunk-3276a2f0"
	],
	"./institution_account_roles/add.vue": [
		"29d3",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-6b974e32"
	],
	"./institution_account_roles/detail-pages.vue": [
		"7181",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-0d2aab94",
		"chunk-50aec6da"
	],
	"./institution_account_roles/edit.vue": [
		"dd48",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-4fd41a65"
	],
	"./institution_account_roles/list.vue": [
		"2cce",
		"chunk-1ec6ab12",
		"chunk-374ac0dc"
	],
	"./institution_account_roles/view.vue": [
		"ec4e",
		"chunk-1ec6ab12",
		"chunk-8cc7e152"
	],
	"./institution_accounts/add.vue": [
		"771c",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-59b0476e"
	],
	"./institution_accounts/edit.vue": [
		"ff24",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-ed4672ec"
	],
	"./institution_accounts/list.vue": [
		"3450",
		"chunk-1ec6ab12",
		"chunk-01f35afb"
	],
	"./institution_accounts/resetpassword.vue": [
		"2330",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-4333da55"
	],
	"./institution_accounts/view.vue": [
		"0f23",
		"chunk-1ec6ab12",
		"chunk-c6ae0380"
	],
	"./institution_admissions_uploads/add.vue": [
		"9426",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-718554b7"
	],
	"./institution_admissions_uploads/edit.vue": [
		"7e0c",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-0e2615c1"
	],
	"./institution_admissions_uploads/list.vue": [
		"ba8e",
		"chunk-1ec6ab12",
		"chunk-16c46deb"
	],
	"./institution_admissions_uploads/view.vue": [
		"786e",
		"chunk-1ec6ab12",
		"chunk-0c4a0a36"
	],
	"./institution_campuses/add.vue": [
		"02a5",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-3dd0e4ac"
	],
	"./institution_campuses/edit.vue": [
		"0ca4",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-7ce292b4"
	],
	"./institution_campuses/list.vue": [
		"dd6c",
		"chunk-1ec6ab12",
		"chunk-fad46628"
	],
	"./institution_campuses/view.vue": [
		"854e",
		"chunk-1ec6ab12",
		"chunk-798b68ae"
	],
	"./institution_programmes/add.vue": [
		"29c7",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-e293e2fe",
		"chunk-24962400"
	],
	"./institution_programmes/add_programme_options.vue": [
		"b26b",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-e293e2fe"
	],
	"./institution_programmes/edit.vue": [
		"0f0e",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-e293e2fe",
		"chunk-ef75d830"
	],
	"./institution_programmes/list.vue": [
		"d7a3",
		"chunk-1ec6ab12",
		"chunk-0b9491f8"
	],
	"./institution_programmes/view.vue": [
		"b24c",
		"chunk-1ec6ab12",
		"chunk-33fea378"
	],
	"./institution_schools/add.vue": [
		"09ac",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-06beb455"
	],
	"./institution_schools/edit.vue": [
		"15ea",
		"chunk-1ec6ab12",
		"chunk-2d0b2e68",
		"chunk-687fd2e8"
	],
	"./institution_schools/list.vue": [
		"c640",
		"chunk-1ec6ab12",
		"chunk-df3f7c24"
	],
	"./institution_schools/view.vue": [
		"f2d4",
		"chunk-1ec6ab12",
		"chunk-584a30b3"
	],
	"./payments/list.vue": [
		"624a",
		"chunk-1ec6ab12",
		"chunk-6e76fae8"
	],
	"./payments/view.vue": [
		"2ef6",
		"chunk-1ec6ab12",
		"chunk-04801963"
	],
	"./waec_results/view.vue": [
		"7d57",
		"chunk-1ec6ab12",
		"chunk-639898b7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;